var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('vue-cal',{attrs:{"selected-date":"2018-11-19","time-from":9 * 60,"time-to":19 * 60,"disable-views":['years', 'year'],"hide-weekends":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }